import 'react-app-polyfill/ie11';
import axios from 'axios';
import {
  ConnectedRouter,
  connectRouter,
  routerMiddleware,
} from 'connected-react-router';
import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { reducer as formReducer } from 'redux-form';
import createSagaMiddleware from 'redux-saga';
import App from './App';
import './assets/styles/styles.sass';
import { getParameterFromURL } from './helpers/utils';
import * as reducers from './store';
import sagas from './store/sagas';
import { datadogRum } from '@datadog/browser-rum'
import ReactGA from 'react-ga4';
import { env } from './env';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const userIdParam = getParameterFromURL('buid');

const store = createStore(
  combineReducers({
    ...reducers,
    form: formReducer,
    router: connectRouter(history),
  }),
  composeWithDevTools(
    applyMiddleware(routerMiddleware(history), sagaMiddleware),
  ),
);

sagaMiddleware.run(sagas);

const TOKEN_TYPE = 'Bearer';

axios.defaults.baseURL = env.REACT_APP_BFF_URL;
axios.defaults.headers.common.authorization = `${TOKEN_TYPE} ${env.REACT_APP_BFF_TOKEN}`;
const dd_appId: string = env.REACT_APP_DD_APLICATIONID as string
const dd_clientToken: string = env.REACT_APP_DD_CLIENT_TOKEN as string
const dd_serviceName: string = env.REACT_APP_DD_SERVICE_NAME as string
const dd_site: string = env.REACT_APP_DD_SITE as string
const dd_env: string = env.REACT_APP_DD_ENV as string


if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
  const tagManagerArgs = {
    dataLayerName: 'datalayer',
    gtmId: 'GTM-5RLTMDH',
    ...(userIdParam && {
      dataLayer: {
        userId: userIdParam,
      },
    }),
  };

  TagManager.initialize(tagManagerArgs);

  ReactGA.initialize("G-DMHZN1VDRG");
}

if (env.REACT_APP_ENVIRONMENT === 'production') {

  datadogRum.init({
    applicationId: dd_appId,
    clientToken: dd_clientToken,
    site: dd_site,
    service: dd_serviceName,
    env: dd_env,
    version: '1.0.0',
    sampleRate: 50,
    sessionReplaySampleRate: 0, // if not included, the default is 100
    trackResources: true,
    trackLongTasks: true,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
